const columnsWidths = {
    carLogistId: 200,
    expander: 45,
    row: 45,
};

export const defaultColumnWidth = (id) => columnsWidths[id] || 150;
